import { styled } from '@mui/material'
import { Button } from '@biolumina/ui/components/button/button'

export const StyledHeaderLink = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'external' && prop !== 'prompt'
})(({ theme, strokeWidth = 0 }) => ({
  fontSize: '0.75rem',
  color: theme.palette.primary.main,
  textAlign: 'center',
  lineHeight: 1.3,
  fontWeight: 500,

  svg: {
    stroke: 'currentColor',
    strokeWidth
  },

  '&.ghost': {
    textDecoration: 'underline',
    fontWeight: 700,
    color: theme.palette.tertiary.main,
  },
  
  '&:not(.blue, .prev, .next)': {
    padding: 0,
  },
  '&.prev, &.next': {
    background: 'transparent',
    padding: 0,
    textAlign: 'right',
    fontWeight: theme.typography.fontWeightBold,
    svg: {
      color: 'white',
      marginRight: theme.spacing(0.5),
      backgroundColor: theme.palette.secondary.main,
      borderRadius: '50%',
      padding: theme.spacing(0.5),
    },

    '&.prev': {
      textAlign: 'left',
      svg: {
        marginRight: theme.spacing(0.5),
      },
    },
    '&.next': {
      svg: {
        marginLeft: theme.spacing(0.5),
      },
    },
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: '.875rem',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '1rem',
  },
}))
